import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)
 const isMobile  = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

const store = new Vuex.Store({
    state: {
       user:null,
      loggedin:false,
      isMobile:isMobile
    },
    mutations: {
      login (state,user) {
        state.user = user
        state.loggedin = true;
      },
      logout(state) {
        // this.state.user = null;
        state.loggedin = false
      },
    
      
    }
  })

  export default store;


// WEBPACK FOOTER //
// ./src/store.js